import { createTheme } from "@mui/material/styles";

// Create a theme instance.

export const defaultPrimaryColor = "#E77843";
export const defaultLightPrimary = "#FCEEE8";
export const defaultPrimaryLightColor = "#FFC3B9"
export const defaultBgGray = "#B3B5C6";
export const defaultInfoColor = "#1C2536";
export const defaultLightInfoColor = "#2E3646";
export const defaultBgSuccessColor = "#1ABC86";
export const defaultBgLightWhite = "#FFFFFF";
export const defaultDisableColor = "#C8D3D9";
export const defaultBgRejectColor = "#EF627A";
export const defaultBgBlueColor = "#4E85C5";
export const defaultBgBlack = "#131A28";
export const defaultBgDarkBlack = "#222222";
export const defaultBgLightBlack = "#B6B6B6";
export const defaultBackgroundColor = "#CCCCCC";
export const defaultBgDarkCyan = "#1ba39c1a";
export const defaultBgPurple = "#646CE1";
export const defaultBgTrendRed = "#FDE8EB";
export const defaultBgTrendOrange = "#FFF5E5";
export const defaultBgLightGreen = "#70CC4A";
export const defaultBgTrendGreen = "#469D22";
export const defaultSkyBlue = "#F1F6F8";
export const defaultdarkSkyBlue = "#EBF4FF";
export const defaultDisableIcon = "#858585";
export const defaultLightYellow = '##F6CF46';
export const defaultTomoto = '#E77843';
export const defaultDarkGray = "#5F5F5F";
export const defaultWhite = "#F3F3F3";
export const thirdWhiteShade  = "#FFFFFFCC"
export const secondaryYellow = '#F6CF46';
export const defaultBlueLinearGradient = "#2B65D0"
export const defaultRichOrange = '#D45A30'
export const grey600= '#5D6679'
export const success = '#10A760'
export const secondaryBlack = "#131313"
export const  secondaryGreen = "#05C283"
export const thirdBlack = "#2A2A2A"
export const secondaryLightTomoto = '#FDA181'
export const neutralGray= '#737373 '
export const neutralBlack100 = '#0A0A0A'
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: defaultPrimaryColor,
      light : defaultPrimaryLightColor,
      richOrange : defaultRichOrange,
      
    },
    lightYellow : {
      light : '#FEDF87',
      main : '#F7D046',
      secondary : secondaryYellow,
    },
    lightTomato : {
      main : defaultTomoto,
      secondary : secondaryLightTomoto
    },
    lightPrimary: {
      main: defaultLightPrimary,
    },
    info: {
      main: defaultInfoColor,
    },
    lightInfo: {
      main: defaultLightInfoColor,
    },
    bgSuccess: {
      main: defaultBgSuccessColor,
    },
    bgWhite: {
      main: defaultBgLightWhite,
      secondary : defaultWhite,
      third : thirdWhiteShade,
    },
    bgBlack: {
      main: defaultBgBlack,
      secondary : secondaryBlack,
      third : thirdBlack,
      neutral100 : neutralBlack100
    },
    disable: {
      main: defaultDisableColor,
    },

    error: {
      main: defaultBgRejectColor,
    },
    bgGray: {
      main: defaultBgGray,
    },
    bgBlue: {
      main: defaultBgBlueColor,
    },
    bgDarkBlack: {
      main: defaultBgDarkBlack,
    },
    bgLightBlack: {
      main: defaultBgLightBlack,
    },
    bgLightGreen: {
      main: defaultBgLightGreen,
    },
    bgTrendGreen: {
      main: defaultBgTrendGreen,
      secondary : secondaryGreen

    },
    bgTrendRed: {
      main: defaultBgTrendRed,
    },
    backgroundDefaultColor: {
      main: defaultBackgroundColor,
    },
    bgCyan: {
      main: defaultBgDarkCyan,
    },
    bgPurple: {
      main: defaultBgPurple,
    },
    bgTrendOrange: {
      main: defaultBgTrendOrange,
    },
    bgSkyBlue: {
      main: defaultSkyBlue,
    },
    bglightBlue: {
      main: defaultdarkSkyBlue,
      blueGradient : defaultBlueLinearGradient
    },
    bgDarkGray : {
      main : defaultDarkGray,
      grey600 :grey600,
      neutral : neutralGray
    },
    success : {
      main : success
    },
    background: { default: "#F5F6FF" },
  },
  typography: {
    button: {
      textTransform: "none",
    },
        fontFamily: "Satoshi, Arial, sans-serif",
  },
  components: {
    // Name of the component
    MuiButtonBase: {
      defaultProps: {
        // The props to change the default for.
        //disableRipple: true, // No more ripple, on the whole application 💣!
        disableTouchRipple: true,
      },
    },
    // MuiAlert: {
    //   styleOverrides: {
    //     standardSuccess: {
    //       backgroundColor: "#ABC9BB",
    //     },
    //   },
    // },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: defaultPrimaryColor,
    },
    lightPrimary: {
      main: defaultLightPrimary,
    },
    info: {
      main: defaultInfoColor,
    },
    bgWhite: {
      main: defaultBgLightWhite,
    },
    error: {
      main: defaultBgRejectColor,
    },
    bgSuccess: {
      main: defaultBgSuccessColor,
    },
    bgGray: {
      main: defaultBgGray,
    },
    bgBlue: {
      main: defaultBgBlueColor,
    },
    bgBlack: {
      main: defaultBgBlack,
    },
    bgDarkBlack: {
      main: defaultBgDarkBlack,
    },
    bgLightBlack: {
      main: defaultBgLightBlack,
    },
    bgLightGreen: {
      main: defaultBgLightGreen,
    },
    bgTrendGreen: {
      main: defaultBgTrendGreen,
    },
    bgTrendRed: {
      main: defaultBgTrendRed,
    },
    backgroundDefaultColor: {
      main: defaultBackgroundColor,
    },
    bgCyan: {
      main: defaultBgDarkCyan,
    },
    bgPurple: {
      main: defaultBgPurple,
    },
    bgTrendOrange: {
      main: defaultBgTrendOrange,
    },
    bgSkyBlue: {
      main: defaultSkyBlue,
    },
    bglightBlue: {
      main: defaultdarkSkyBlue,
    },
    disable: {
      main: defaultDisableIcon,
    },
  },
  typography: {
    button: {
      textTransform: "none",
    },
  },
  components: {
    // Name of the component
    MuiButtonBase: {
      defaultProps: {
        // The props to change the default for.
        //disableRipple: true, // No more ripple, on the whole application 💣!
        disableTouchRipple: true,
      },
    },
    // MuiAlert: {
    //   styleOverrides: {
    //     standardSuccess: {
    //       backgroundColor: "#ABC9BB",
    //     },
    //   },
    // },
  },
});
